import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NavBtn } from './navbtn';
@Injectable({
  providedIn: 'root'
})
export class NavbtnService {
 private subject = new Subject<NavBtn>();
  constructor() { }
     onAdd(): Observable<NavBtn> {
        return this.subject;
    }
    addbtn(btnobj:{}){
     
        this.navbars(new NavBtn(btnobj) );   


    }
    
    emptyBtn(){
       this.subject = new Subject<NavBtn>();
    }
    
    navbars(navbar: NavBtn) {
       
        this.subject.next(navbar);
    }
}
